import React from 'react';
import { CheckIcon, DownloadIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
const benefits = [{
  title: 'Supervivencia técnica',
  detail: 'El paso a paso para no estrellar tu inversión en la primera semana: qué hace volar realmente un dron y cómo mantenerlo en el aire.'
}];
export function Hero() {
  return <header className="w-full bg-ink-950 text-white" data-id="element-119" data-mp="4n1oh0f7oswq">
      <div className="border-b border-white/10 bg-ink-900" data-id="element-120" data-mp="1297ahz3tqr77">
        <div className="mx-auto flex max-w-content items-center justify-center gap-3 px-6 py-3 text-center" data-id="element-121" data-mp="128pgza8jqr2z">
          <span className="h-2 w-2 shrink-0 rounded-full bg-flare-500" aria-hidden="true" data-id="element-122" data-mp="x8bc2128rx96" />
          <p className="text-[11px] font-semibold uppercase tracking-[0.16em] text-white/70 sm:text-xs" data-id="element-123" data-mp="sde28rx51jv8">
            El mejor punto de partida para amantes de los drones en LATAM — Edición 2026
          </p>
        </div>
      </div>

      <div className="px-6 pt-16 lg:pt-20" data-id="element-124" data-mp="382p4d9lap7jk">
        <h1 className="mx-auto max-w-4xl text-center text-4xl font-black leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl" data-id="element-125" data-mp="380vy3velgpc3">
          Domina tus primeros vuelos con drones{' '}
          <span className="text-flare-500" data-id="element-126" data-mp="3o6khtotcoo8a">sin arriesgar tu equipo ni recibir multas</span>
        </h1>
      </div>

      <div className="mx-auto mt-8 w-full max-w-[1700px] px-2 sm:px-6 lg:mt-10" data-id="element-127" data-mp="399tex5kgwudx">
        <img src="https://cdn.magicpatterns.com/uploads/hknJ1SNcyVUjoTYU2sSuDw/Diseno_sin_titulo_(51).png" alt="Mega Pack Drone Commander: los 4 tomos impresos, los 3 bonos en tablets, un dron con su control y el material en laptop" className="mx-auto block w-full" width={1920} height={1080} data-id="element-128" data-mp="3e8ehhbn6zq5j" />
      </div>

      <div className="mx-auto max-w-content px-6 pb-16 lg:pb-20" data-id="element-129" data-mp="2ql6a8o67e70v">
        <div className="mx-auto mt-6 max-w-3xl text-center lg:mt-10" data-id="element-130" data-mp="2viev4wiqkp5t">
          <p className="text-lg leading-relaxed text-white/70" data-id="element-131" data-mp="2vgllr9gqnqu4">
            ¿Te apasionan los drones pero no sabes por dónde empezar? No gastes dinero en un equipo
            que no necesitas ni te arriesgues a multas de la autoridad aeronáutica por desconocer las
            leyes.
          </p>
          <p className="mt-5 text-base leading-relaxed text-white/55" data-id="element-132" data-mp="s3uqvwnx98am">
            Drone Commander es el{' '}
            <strong className="font-semibold text-white/80" data-id="element-133" data-mp="ic87ve5ce4xb">Mega Pack de iniciación</strong> que te
            enseña desde la ciencia básica de vuelo hasta cómo obtener tu licencia oficial en
            Latinoamérica. Todo lo que un principiante necesita saber para volar con seguridad,
            legalidad y confianza.
          </p>
        </div>

        <div className="mt-10 flex flex-col items-center text-center" data-id="element-134" data-mp="16345irwhbuch">
          <CtaButton label="Quiero el acceso ahora" size="lg" data-id="element-135" data-mp="1126m6bzqgu9e" />
          <p className="mt-4 flex items-center gap-2 text-xs text-white/50" data-id="element-136" data-mp="114kkctppmml6">
            <DownloadIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-137" data-mp="x0uwy7krub1q" />
            Acceso instantáneo después de pagar. Descarga en PDF. Lee en cualquier dispositivo.
          </p>
        </div>

        <ul className="mx-auto mt-14 grid max-w-5xl gap-6 sm:grid-cols-3" data-id="element-138" data-mp="3hq23uqpg9u6o">
          {benefits.map(benefit => {})}
        </ul>
      </div>
    </header>;
}